<template>
    <div class="app flex-row align-items-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-6">
                    <div class="clearfix">
                        <h1 class="float-left display-3 mr-4">404</h1>
                        <h4 class="pt-3">Oops! You're lost.</h4>
                        <p class="text-muted">The page you are looking for was not found.</p>
                    </div>
                </div>
            </div>
            <!--<b-row>-->
            <!--<b-col class="text-center">-->
            <!--<b-link :to="{name: 'Frontend'}" class="btn btn-outline-primary">На главную</b-link>-->
            <!--<b-link :to="{name: 'Cabinet'}" class="btn btn-primary">В кабинет</b-link>-->
            <!--</b-col>-->
            <!--</b-row>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'error-404'
    }
</script>


// WEBPACK FOOTER //
// PageNotFound.vue?10b1e630